import {useEffect} from 'react';
import {registerMicLoginCallback, unregisterMicLoginCallback} from '@Components/ai-prompt-box/libraries/ai-prompt-box-mic.library';

export const useMicLoginCallback = (id: string, onLoginSuccess: () => void): void => {
  useEffect(() => {
    registerMicLoginCallback(id, onLoginSuccess);
    return (): void => {
      unregisterMicLoginCallback(id);
    };
  }, [id, onLoginSuccess]);
};
